import { IFormOfferings } from 'legacy/lut/classes/models/partner360/IFormOfferings'

import Logger from 'core/utils/Logger'

export const parseProgramOfferings = (jsonString: string): IFormOfferings[] => {
  try {
    return JSON.parse(jsonString) as IFormOfferings[]
  } catch (e) {
    Logger.error(`AllProgramOfferingsJson: ${e}`)
    return []
  }
}
